/**
 * Shared Web Audio context for the whole app (metronome + feedback sounds).
 * Browsers limit the number of AudioContexts, and a single context keeps all
 * scheduled audio on one clock.
 */
let sharedCtx: AudioContext | null = null;

export function getSharedAudioContext(): AudioContext {
  if (!sharedCtx) {
    sharedCtx = new AudioContext();
  }
  if (sharedCtx.state === "suspended") {
    sharedCtx.resume();
  }
  return sharedCtx;
}
